import { styled } from '@mui/material';
import { StyledLink } from '../../../styles/shared';

export const AStyled = styled(StyledLink)(({ theme }) => ({
  fontSize: theme.fonts.utility.size(9),
}));
